let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);
  const grid = document.querySelector(".block__grid");
  animateCSSGrid.wrapGrid(grid, { duration: 600 });
  var looks = document.querySelectorAll('.look');
	
 looks.forEach(function(look) {	 
	 var lookImg = look.querySelector('.card__img');
	 lookImg.addEventListener("click", () => {
		 if(look.classList.contains('card--expanded')) {
			 look.classList.remove('card--expanded')
		 } else {
			  document.querySelectorAll(".look.card--expanded").forEach((card) => {
				  card.classList.remove("card--expanded");
			});
			 look.classList.add('card--expanded');
		 }
	 });
 });